// @flow
import { SERVER_ADDRESS, fetchGet } from '../util/actionsUtil';

export const MONTHLY_REPORT_LOADING = 'MONTHLY_REPORT_LOADING';
export const MONTHLY_REPORT_SUCCESS = 'MONTHLY_REPORT_SUCCESS';
export const MONTHLY_REPORT_ERROR = 'MONTHLY_REPORT_ERROR';

export function getMonthlyReport(month: number, year: number) {
  return ((dispatch: Function) => {
    fetchGet(`${SERVER_ADDRESS}/monthlyReport/get/${year}/${month}`,
      (response) => {
        dispatch({
          type: MONTHLY_REPORT_SUCCESS,
          data: response,
        });
      },
      (error) => {
        dispatch({
          type: MONTHLY_REPORT_ERROR,
          error: error.message,
        });
      });
    dispatch({
      type: MONTHLY_REPORT_LOADING,
    });
  });
}



// WEBPACK FOOTER //
// ./client/src/actions/monthlyReportActions.js